module.exports = __webpack_public_path__ + "img/arrow-right-short.070d17b3.svg";